import RightDocSidebar from "../../components/RightSidebar";
import Suppliers from "../../components/Procurement Module/Suppliers";
import Purchases from "../../components/Procurement Module/Purchases";
import PurchasePayments from "../../components/Procurement Module/PurchasePayments";
import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function Procurement() {
    const groups = [
        {
            title: "1. Suppliers",
            expandable: false,
            items: [{ id: "suppliers", label: "Suppliers" }],
        },
        {
            title: "2. Purchases",
            expandable: false,
            items: [{ id: "purchases", label: "Purchases" }],
        },
        {
            title: "3. Purchase Payments",
            expandable: false,
            items: [{ id: "purchase-payments", label: "Purchase Payments" }],
        },
    ];

    return (
        <div className="flex gap-12">

            {/* MAIN CONTENT */}
            <div className="flex-1 space-y-16">

                {/* HERO — SAME FORMAT EVERYWHERE */}
                <section className="bg-white rounded-xl border border-slate-200 p-10">
                    <h1 className="text-2xl font-bold text-slate-900 mb-4">
                        Procurement Management
                    </h1>
                    <p className="text-md text-slate-600 max-w-3xl">
                        The Procurement module helps manage suppliers, purchases, and
                        supplier payments to ensure smooth inventory and expense control.
                    </p>
                </section>

                {/* MODULES */}
                <Suppliers />
                <Purchases />
                <PurchasePayments />

                {/* <section className="border-t pt-8 mt-12">
                    <p className="text-slate-600">
                        Next, explore{" "}
                        <Link to="/docs/accounting" className="font-medium text-[#C9A24E]">
                            Accounting Module
                        </Link>.
                    </p>
                </section> */}
                          <DocNavigation
                    previous={{
                        title: "Expense Module",
                        link: "/docs/expenses"
                    }}
                    next={{
                        title: "Accounting Module",
                        link: "/docs/accounting"
                    }}
                />
            </div>

            {/* RIGHT SIDEBAR */}
            <RightDocSidebar groups={groups} />

        </div>
    );
}
